import { Button } from '@ridemaadi/ui';
import { startGoogleSignIn } from './site';

export function PublicCta({ heading = 'Ready to ride with your group?' }: { heading?: string }) {
  return (
    <section className="rounded-2xl bg-primary/10 px-6 py-10 text-center sm:px-10" aria-labelledby="public-cta-heading">
      <h2 id="public-cta-heading" className="text-xl font-bold sm:text-2xl">
        {heading}
      </h2>
      <p className="mx-auto mt-2 max-w-lg text-sm text-muted sm:text-base">
        Sign in with Google to create rides, invite riders, and manage your motorcycle community.
      </p>
      <div className="mx-auto mt-6 max-w-md">
        <Button
          fullWidth
          size="lg"
          className="rounded-2xl shadow-md shadow-primary/25"
          onClick={() => startGoogleSignIn()}
        >
          Sign in with Google
        </Button>
      </div>
    </section>
  );
}
